module.exports = __webpack_public_path__ + "img/logo-tb.e64ec234.png";